import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Page } from "@models/page";
import { StarredEvents } from "@models/starred-events";
import { catchError, map, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";
import { SnackBarService } from "./snack-bar.service";
import { EventInfoResponseBody } from "./types/events-management-response.type";

@Injectable({
  providedIn: "root",
})
export class StarredEventsService {
  private readonly baseUrl = `${environment.API_BACKEND}`;

  constructor(
    private http: HttpClient,
    private snackbarService: SnackBarService,
    private authService: AuthService,
  ) {}

  getStarredEvents(pageNumber?: number, isActive: boolean = true) {
    const params = new HttpParams()
      .set("page", pageNumber ?? 0)
      .set("per_page", 4)
      .set("active_only", isActive);

    return this.http
      .get<Page<EventInfoResponseBody>>(`${this.baseUrl}/my_starred_events`, {
        params: params,
      })
      .pipe(
        map((response) => {
          response.data.map((event) => (event.is_favorite = true));
          return response;
        }),
      );
  }

  updateStarredEvent(eventId: number) {
    const body = {
      events_to_update: [eventId],
    };

    const isAuthenticated = !!this.authService.getLocalStorageUserInfo();

    if (!isAuthenticated) {
      this.snackbarService.openSnackBar(
        "É necessário fazer login para poder favoritar um evento",
        "Fechar",
        "error",
      );

      return of(null);
    }

    return this.http
      .patch<StarredEvents>(`${this.baseUrl}/update_starred_events`, body)
      .pipe(
        tap((response) => {
          const userInfo = this.authService.getLocalStorageUserInfo();
          if (userInfo) {
            this.authService.updateLocalStorageUserInfo({
              ...userInfo,
              ...response,
            });
          }
        }),
        catchError((_err: Error) => {
          this.snackbarService.openSnackBar(
            "Você fez muitas tentativas seguidas. Aguarde alguns segundos antes de tentar novamente.",
            "Fechar",
            "error",
          );
          return of(null);
        }),
      );
  }
}
